import { Link } from "react-router-dom";
import { Truck, ShieldCheck, Leaf, Headphones, Facebook, Instagram, Linkedin } from "lucide-react";
import { SosLogo } from "@/components/SosLogo";

export default function Footer({ settings }) {
    const phone = settings?.contact_phone || "+351 000 000 000";
    const email = settings?.contact_email || "geral@sostoners.pt";
    const address = settings?.contact_address;
    return (
        <footer className="bg-ink text-white mt-24" data-testid="site-footer">
            <div className="border-b border-white/15">
                <div className="container-edge grid grid-cols-2 md:grid-cols-4 gap-6 py-10">
                    {[
                        { icon: Truck, t: "Envio Rápido", s: "1-3 dias úteis" },
                        { icon: ShieldCheck, t: "Garantia", s: "Até 24 meses" },
                        { icon: Leaf, t: "Sustentável", s: "Economia circular" },
                        { icon: Headphones, t: "Suporte Humano", s: "Técnicos certificados" },
                    ].map(({ icon: Icon, t, s }) => (
                        <div key={t} className="flex items-start gap-3">
                            <Icon className="text-magenta shrink-0 mt-1" size={22} />
                            <div>
                                <div className="font-bold uppercase text-sm tracking-wider">{t}</div>
                                <div className="text-xs text-white/60 font-mono mt-1">{s}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container-edge grid md:grid-cols-4 gap-10 py-14">
                <div>
                    <SosLogo size={56} dark customLogoUrl={settings?.logo_url} />
                    <p className="text-white/60 text-sm mt-5 font-mono leading-relaxed">
                        A solução inteligente e sustentável para impressão e informática.
                    </p>
                    {(settings?.facebook || settings?.instagram || settings?.linkedin) && (
                        <div className="flex gap-2 mt-5">
                            {settings?.facebook && <a href={settings.facebook} target="_blank" rel="noopener noreferrer" className="border border-white/30 p-2 hover:bg-magenta hover:border-magenta"><Facebook size={14} /></a>}
                            {settings?.instagram && <a href={settings.instagram} target="_blank" rel="noopener noreferrer" className="border border-white/30 p-2 hover:bg-magenta hover:border-magenta"><Instagram size={14} /></a>}
                            {settings?.linkedin && <a href={settings.linkedin} target="_blank" rel="noopener noreferrer" className="border border-white/30 p-2 hover:bg-magenta hover:border-magenta"><Linkedin size={14} /></a>}
                        </div>
                    )}
                </div>
                <div>
                    <div className="label-mono text-white/40 mb-4">Loja</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/loja/toners-compativeis" className="hover:text-magenta">Toners Compatíveis</Link></li>
                        <li><Link to="/loja/toners-originais" className="hover:text-magenta">Toners Originais</Link></li>
                        <li><Link to="/loja/tinteiros" className="hover:text-magenta">Tinteiros</Link></li>
                        <li><Link to="/loja/impressoras-recondicionadas" className="hover:text-magenta">Impressoras</Link></li>
                        <li><Link to="/loja/computadores-recondicionados" className="hover:text-magenta">Computadores</Link></li>
                        <li><Link to="/impressoras" className="hover:text-magenta">Por modelo de impressora</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-mono text-white/40 mb-4">Empresa</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/sobre" className="hover:text-magenta">Sobre Nós</Link></li>
                        <li><Link to="/loja/assistencia-tecnica" className="hover:text-magenta">Assistência Técnica</Link></li>
                        <li><Link to="/conta/login" className="hover:text-magenta">Área de Cliente</Link></li>
                        <li><a href={`mailto:${email}`} className="hover:text-magenta">Contactos</a></li>
                    </ul>
                    <div className="label-mono text-white/40 mt-6 mb-2">Legal</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/legal/termos" className="hover:text-magenta">Termos & Condições</Link></li>
                        <li><Link to="/legal/privacidade" className="hover:text-magenta">Privacidade</Link></li>
                        <li><Link to="/legal/devolucoes" className="hover:text-magenta">Devoluções</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-mono text-white/40 mb-4">Contactos</div>
                    <div className="text-sm font-mono space-y-1">
                        <div>{phone}</div>
                        <div>{email}</div>
                        {address && <div className="text-white/60">{address}</div>}
                    </div>
                    <div className="label-mono text-white/40 mt-6 mb-2">Pagamento</div>
                    <div className="flex flex-wrap gap-2">
                        {["Multibanco", "MB Way", "Visa", "Mastercard"].map((m) => (
                            <span key={m} className="border border-white/30 text-xs font-mono px-2 py-1">{m}</span>
                        ))}
                    </div>
                </div>
            </div>

            <div className="border-t border-white/15">
                <div className="container-edge py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-mono text-white/40">
                    <div>© {new Date().getFullYear()} {settings?.company_name || "SOSTONERS"} — Todos os direitos reservados.</div>
                    <div>Imprima mais. Pague menos.</div>
                </div>
            </div>

            <div className="overflow-hidden border-t border-white/10">
                <div className="font-display font-black text-[18vw] leading-[0.85] text-white/[0.04] uppercase whitespace-nowrap select-none -mb-6">
                    SOSTONERS
                </div>
            </div>
        </footer>
    );
}
